import React, { Fragment } from 'react'
import { Heading, Timer } from '@myxplor/ui'

const SuccessView = ({onComplete}) => (
  <Fragment>
    <Heading small>Your registration details have been retrieved!</Heading>
    <Timer secs={5} message="You will be redirected to your organisation" done={onComplete} />
  </Fragment>
)

export default SuccessView



// WEBPACK FOOTER //
// ./src/providers-registrations/onboarding/views/success.jsx